// Single source of truth for TenantSeal Plus upgrade CTA copy across every surface.
// Eligible free user -> trial CTA; ineligible free user -> standard paid CTA; trialing -> none.
export function getPlanCta({ trialEligible, trialing } = {}) {
  if (trialing) {
    return { state: "trialing", title: null, price: null, priceSub: null, cta: null };
  }
  if (trialEligible) {
    return {
      state: "trial",
      title: "Try TenantSeal Plus free for 7 days",
      price: "$0 today, then $6/month unless canceled.",
      priceSub: "Cancel anytime.",
      cta: "Start 7-day free trial",
    };
  }
  return {
    state: "paid",
    title: "Upgrade to TenantSeal Plus",
    price: "$6/month",
    priceSub: "cancel anytime",
    cta: "Upgrade to TenantSeal Plus",
  };
}
